import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import useAxiosPrivate from '../../../hooks/useAxiosPrivate'
import { toast } from 'sonner'
import useAuth from '../../../hooks/useAuth'
import moment from 'moment'
const StepFour = ({
  selectedAppointment,
  selectedGP,
  contactDetails,
  setStep,
  dependant,
}) => {
  const axios = useAxiosPrivate()
  const { auth, userPolicy, showLoader, setShowLoader, createInfo, setShowPaymentRedirect } = useAuth()

  const [submittingBooking, setSubmittingBooking] = useState(false)

  const [hasAccess, setHasAccess] = useState(false)
  const [accessMode, setAccessMode] = useState('fallback') // 'api' | 'fallback'
  const [accessByProduct, setAccessByProduct] = useState({})
  const [product, setProduct] = useState(
    {
      "title": "GP Services",
      "link": "gp-service",
      "bookable": true,
      "description": "Book a GP appointment for non-urgent conditions.",
      "paymentLink": "https://buy.stripe.com/test_5kQ6oHeW7a7hama123cbC0b"
    }
  )
  useEffect(() => {
    setHasAccess(checkProductAccess(product.title))
  }, [])

  useEffect(() => {
    if (!auth?.token) return
    let cancelled = false
    setAccessMode('fallback')
    axios
      .post('/service-access/check', {
        product_titles: [product.title],
        ...(process.env.REACT_APP_ENV !== 'production'
          ? {
            policy_override: {
              product: userPolicy?.product,
              status: userPolicy?.status,
              department: userPolicy?.department,
            },
          }
          : {}),
      })
      .then((response) => {
        if (cancelled) return
        const byProduct = response?.data?.result?.by_product
        if (byProduct && typeof byProduct === 'object') {
          setAccessByProduct(byProduct)
          setAccessMode('api')
        }
      })
      .catch(() => {
        if (cancelled) return
        setAccessMode('fallback')
      })

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.token, userPolicy?.id])

  // Process payment - placeholder function
  const processPayment = (product) => {
    if (!!product?.paymentLink) {
      // Append the parameter to the URL
      const finalUrl = `${product.paymentLink}?booking=true`;

      window.location.href = finalUrl;
    } else {
      createInfo('error', 'Payment link not available.');
    }
  }

  // Check overall service access based on user policy
  const checkOverallServiceAccess = () => {
    return !(
      ['SWB OH+', 'SWB OH+ Only'].includes(userPolicy?.product) ||
      !['live', 'expiring'].includes(userPolicy?.status)
    )
  }

  // Check access for specific products
  const checkProductAccess = (productTitle) => {
    console.log(accessMode)
    if (accessMode === 'api') {
      return !!accessByProduct?.[productTitle]
    }

    // First check overall access
    if (!checkOverallServiceAccess()) return false

    if (['SAS', 'Mutual'].includes(userPolicy?.department)) return true
    if (['SWB OH+', 'SWB OH+ Only'].includes(userPolicy?.department)) return false

    if (![
      'Counselling',
      'Mindfulness',
      'Relaxation Room Live',
      'Nurse Support',
      'Menopause Support',
      'GP Services',
      'SAS Gym',
      'Happier Healthier You',
      'HHY Community',
      'Physiotherapy',
      'Preparing Parents',
      'Food Intolerance Testing',
      'Financial Wellbeing',
      'Manspace',
      'Pupil Yoga',
      'Pastoral Resources',
      'Awards & Programmes',
      'Ask the PT'
    ].includes(productTitle)) return false

    switch (productTitle) {
      case 'Counselling':
        if (userPolicy?.department === 'AIS' || userPolicy?.product === 'SWB Essential') return false
        return true
      case 'GP Services':
        if (userPolicy?.department === 'AIS' || userPolicy?.product === 'SWB Essential') return false
        return true
      case 'Happier Healthier You':
        if (userPolicy?.department === 'AIS' || userPolicy?.product === 'SWB Essential') return false
        return true
      case 'Physiotherapy':
        if (userPolicy?.department === 'AIS' || userPolicy?.product === 'SWB Essential') return false
        return true
      case 'Preparing Parents':
        if (userPolicy?.department === 'AIS' || userPolicy?.product === 'SWB Essential') return false
        return true
      case 'Pupil Counselling':
        if (userPolicy?.department === 'AIS' || userPolicy?.product === 'SWB Essential') return false
        return true
      default:
        return true
    }
  }

  const bookingIntent = () => {
    setShowLoader(true)
    setSubmittingBooking(true)
    axios
      .post('/bookings/intent', {
        user_id: auth?.user?.id,

        policy_id: userPolicy?.id,
        policy_reference: userPolicy?.reference,

        staff_id: auth?.user?.client?.staff_id,
        staff_name: auth?.user?.client?.name,
        staff_reference: auth?.user?.client?.reference,

        org_name: auth?.user?.client?.organisation?.name,
        org_urn: auth?.user?.client?.organisation?.unique_reference,

        department: userPolicy?.department,
        appointment: selectedAppointment,
        dependant: dependant,
        gp: selectedGP,
        reason: selectedAppointment.reason,
        consultationType: selectedAppointment.attributes.consultationType,
        contactDetails: contactDetails,
        attachments: localStorage.getItem('uploadedFiles')
          ? JSON.parse(localStorage.getItem('uploadedFiles'))
          : null,
      })
      .then((response) => {
        setShowLoader(false)
        if (response.data.error) {
          console.log(response.data)
          toast.error(response.data.message)
          return
        }
        const stripeUrl = response.data.result.url;
        console.log(stripeUrl)
        if (stripeUrl) {
          console.log("Redirecting to Stripe:", stripeUrl);
          window.location.href = stripeUrl;
        } else {
          toast.error('Payment link could not be generated.');
        }
      })
      .catch((error) => {
        toast.error('Failed to create booking. Please try again.')
        // Handle error, show message to user
      }).finally(() => {
        setShowLoader(false)
      })
  }

  const confirmBooking = () => {
    if (!hasAccess) {
      setShowPaymentRedirect(true)
      setTimeout(() => {
        if (!hasAccess) {
          processPayment(product, 0);
        }
      }, 4000)
    } else {
      setShowLoader(true)
      axios
        .post('/bookings/create', {
          user_id: auth?.user?.id,

          policy_id: userPolicy?.id,
          policy_reference: userPolicy?.reference,

          staff_id: auth?.user?.client?.staff_id,
          staff_name: auth?.user?.client?.name,
          staff_reference: auth?.user?.client?.reference,

          org_name: auth?.user?.client?.organisation?.name,
          org_urn: auth?.user?.client?.organisation?.unique_reference,
          
          department: userPolicy?.department,
          appointment: selectedAppointment,
          dependant: dependant,
          gp: selectedGP,
          reason: selectedAppointment.reason,
          consultationType: selectedAppointment.attributes.consultationType,
          contactDetails: contactDetails,
          attachments: localStorage.getItem('uploadedFiles')
            ? JSON.parse(localStorage.getItem('uploadedFiles'))
            : null,
        })
        .then((response) => {
          setShowLoader(false)
          if (response.data.error) {
            toast.error(response.data.message)
            return
          } else {
            toast.success('Booking created successfully!')
            localStorage.removeItem('uploadedFiles') // Clear uploaded files from local storage
            //redirect to dashboard so user can see their booking
            window.location.href = '/'
          }
        })
        .catch((error) => {
          toast.error('Failed to create booking. Please try again.')
          // Handle error, show message to user
        }).finally(() => {
          setShowLoader(false)
          setSubmittingBooking(false)
      })
    }


  }

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-8 text-portal-dark-blue">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold mb-2">Review details</h1>
        <p className="text-sm text-gray-600">
          Please confirm the details below are correct
        </p>
      </div>

      {/* Phone confirmation */}
      <div className="text-center">
        {selectedAppointment.attributes.consultationType === 'Phone' ? (
          <>
            <p className="text-sm ">
              The HealthHero clinician will call you on:
            </p>
            <p className="font-bold text-lg mt-1">
              {selectedAppointment.phoneNumber}
            </p>
          </>
        ) : (
          <>
            <p className="text-sm ">Your video link will be sent to:</p>
            <p className="font-bold text-lg mt-1">
              {selectedAppointment.email}
            </p>
          </>
        )}
      </div>

      {/* Details Table */}
      <div className="border-t border-b divide-y text-sm">
        <div className="flex justify-between py-3">
          <span className="font-medium ">Patient</span>
          <span>{dependant ? dependant.attributes.fullName : auth?.user?.name}</span>
        </div>
        <div className="flex justify-between py-3">
          <span className="font-medium ">HealthHero clinician</span>
          <span>
            {selectedAppointment.practitionerGender !== 'Male' &&
              selectedAppointment.practitionerGender !== 'Female'
              ? 'General'
              : selectedAppointment.practitionerGender}{' '}
            Clinician
          </span>
        </div>
        <div className="flex justify-between py-3">
          <span className="font-medium ">Appointment type</span>
          <span>{selectedAppointment.attributes.consultationType} call</span>
        </div>
        <div className="flex justify-between py-3">
          <span className="font-medium ">Date and time</span>
          <span>
            {moment(selectedAppointment?.attributes?.start).format(
              'dddd, MMMM D, YYYY [at] HH:mm'
            )}{' '}
            (UK time)
          </span>
        </div>
      </div>

      {/* Notes */}
      <div className="text-sm  space-y-4">
        <p>
          Our clinicians can only conduct consultations with the patient listed
          above. Please check that you have booked the consultation for the
          correct person. Please also note that the doctor may call from a
          private or unknown number.
        </p>
        <p>
          By using this service, you are agreeing to HealthHero's{' '}
          <Link to="https://www.healthhero.com/terms-and-conditions" target='_blank' className="text-portal-medium underline">
            Terms and Conditions
          </Link>{' '}
          and{' '}
          <Link to="https://www.healthhero.com/privacy-policy" target='_blank' className="text-portal-medium underline">
            Privacy Policy
          </Link>
          .
        </p>
      </div>

      {!hasAccess && (
        <p className="text-sm text-red-600">You don’t currently have access to this service. Once you submit the form, you’ll be taken to a payment page to continue.</p>
      )}

      {/* Action buttons */}
      <div className="flex flex-col sm:flex-row justify-center gap-4 pt-6">

        <button
          type="button"
          className="border rounded-md py-2 px-6 font-medium bg-white hover:bg-gray-100 shadow-sm"
          onClick={() => setStep(2)} // Go back to step two
        >
          Edit booking
        </button>

        <button
          type="button"
          disabled={!submittingBooking}
          onClick={() => !hasAccess ? bookingIntent() : confirmBooking()}
          className={`bg-portal-light hover:bg-portal-medium text-white text-center font-semibold py-2 px-6 rounded-md shadow ${!submittingBooking ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {!hasAccess ? 'Continue to Payment' : 'Confirm'}
        </button>
      </div>
    </div>
  )
}

export default StepFour
